import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { loadConfig } from './config';
import './index.css';

const root = createRoot(document.getElementById('root')!);
loadConfig()
  .then((config) =>
    root.render(
      <StrictMode>
        <App config={config} />
      </StrictMode>,
    ),
  )
  .catch((e) =>
    root.render(<p style={{ padding: 24 }}>Configurazione non disponibile: {String(e)}</p>),
  );
